/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Credentials_Update_Email_DescriptionInputs */

const de_account_credentials_update_email_description = /** @type {(inputs: Account_Credentials_Update_Email_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihre neue E-Mail-Adresse ein. Wir senden Ihnen anschließend einen Bestätigungslink an diese Adresse. Erst nach der Bestätigung wird die Änderung wirksam.`)
};

/** @type {(inputs: Account_Credentials_Update_Email_DescriptionInputs) => LocalizedString} */
const en_account_credentials_update_email_description = de_account_credentials_update_email_description;

/**

* @param {Account_Credentials_Update_Email_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_credentials_update_email_description = /** @type {((inputs?: Account_Credentials_Update_Email_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Credentials_Update_Email_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_credentials_update_email_description(inputs)
	return en_account_credentials_update_email_description(inputs)
});